module.exports = __webpack_public_path__ + "img/PXL_20230526_093027176.a062b879.jpg";